
/**
 * @author        quanquan
 * @dateTime      2020-12-12 15:09:08
 * @description   meituanIM utils
 */

import store from '@/conf/home/store'
import { lineToHump } from '@/module/utils'
import { decMsg } from '@/module/components/mtIm/_source/utils'

export const state = {
  /**
   * 当前登录的美团客服状态
   */
  currentCsMtStatus: false,
  /**
   * 当前登录客服状态
   */
  currentCsStatus: false,
  /**
   * 美团聊天k,v
   */
  IMWebsocket: {},
  /**
   * 门店列表数据
   */
  mtImStoreData: [],
  /**
   * 用户列表数据
   */
  mtImUserData: [],
  /**
   * 聊天列表数据
   */
  mtImMsgData: [],
  /**
   * 用户查询入参缓存
   */
  userSearchParams: {
    onlineClientCode: '',
    onlineStoreCode: ''
  },
  /**
   * 选中用户key
   */
  msgSearchParams: {
    onlineStoreCode: '',
    thirdUserId: ''
  },
  /**
   * 消息监听选中门店k
   */
  storeSearchParams: {
    onlineClientCode: '',
    onlineStoreCode: ''
  },
  /**
   * 缓存单挑聊天消息体
   */
  cacheSingleMsg: {},
  /**
   * 缓存密钥列表
   */
  cacheAppSecret: [],
  /**
   * 缓存上报数据
   */
  cacheStoresData: [],
  /**
   * 缓存单条上报数据
   */
  cacheSingleReportItem: {},
  /**
   * 存储ws RongCloud状态
   */
  rongStatus: 0,
  /**
   * 存储ws meituanIM状态
   */
  mtStatus: [],
  /**
   * 缓存当前数据到聊天框 解决消息异步问题
   */
  cacheCurrentChatBoxMsg: {},
  /**
   * 存储更多消息标记
   */
  isMsgMore: true
}

/**
 * 消息提示
 */
export const tooltipNotify = (msg_type, lastMsg) => {
  store.commit('cs/setMsgContent', {
    lastMsgType: 'MT_IM',
    content: (() => {
      switch (Number(msg_type)) {
        case 1:
          return lastMsg
        case 2:
          return '【图片】'
        case 3:
          return '【语音】'
      }
    })()
  })
}

/**
 * 处理返回消息单条记录结构
 */
export const handlerMsgItem = ({ msgContent, appSecret, payloadItem, merCode }) => {
  const p = {}
  _.map(payloadItem, (v, k) => { p[lineToHump(k)] = v })
  return {
    ...p,
    msgContent: decMsg(msgContent, appSecret),
    merCode
  }
}

export const handlerSelfMsgItem = (msgItem) => {
  const p = {}
  _.map(msgItem, (v, k) => { p[_.camelCase(k)] = v })
  return p
}



// WEBPACK FOOTER //
// ./src/js/conf/home/store/meituanIM/utils.js